// extracted by mini-css-extract-plugin
module.exports =  {"header":"a10a3f92e9--header--g1L5_","reviews":"a10a3f92e9--reviews--WyXHo"};